import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NastavnejedinicePopisService } from './nastavnejedinice-popis.service';
import { NastavnajedinicaPopis } from './nastavnejedinice';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';

@Component({
  selector: 'app-nastavnejedinice-popis',
  templateUrl: './nastavnejedinice-popis.component.html',
  styleUrls: ['./nastavnejedinice-popis.component.css'],
  providers: [NastavnejedinicePopisService]
})
export class NastavnejedinicePopisComponent implements OnInit {

  sveNastavnejedinice: NastavnajedinicaPopis[] = [];
  nastavnejediniceOptions: DataTables.Settings = {};
  nastavnejediniceTrigger: Subject<NastavnajedinicaPopis> = new Subject();

  nastavnajedinicaForma: FormGroup;
  nastavnajedinicaEditForma: FormGroup;

  modulId: string;

  svinacinipredavanja: any = [];
  svapodrucjaznanja: any = [];

  constructor(
    private _fb: FormBuilder,
    private _nastavnejedinicePopisService: NastavnejedinicePopisService
  ) { }

  ngOnInit() {
    this.dohvati();
    this.dohvatiSveNacinepredavanja();
    this.dohvatiSvaAktivnaPodrucjaznanja();
    //Tablica početak
    this.nastavnejediniceOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.nastavnajedinicaForma = this._fb.group({
      naziv: [''],
      nacinPredavanja: [''],
      podrucjeZnanja: [''],
      ciljnastavnejedinice: [''],
      rasporedpredavanja: [''],
      fondsati: [''],
      vjezbe: ['']
    });
    this.nastavnajedinicaEditForma = this._fb.group({
      naziv: [''],
      nacinPredavanja: [''],
      podrucjeZnanja: [''],
      aktivan: [''],
      ciljnastavnejedinice: [''],
      rasporedpredavanja: [''],
      fondsati: [''],
      vjezbe: ['']
    });
  }

  pripremiPodatke(modul){
    // console.log(modul);
    this.modulId = modul['id'];
    this.nastavnajedinicaEditForma = this._fb.group({
      naziv: modul['naziv'],
      nacinPredavanja: modul['idnacinpredavanja'],
      podrucjeZnanja: modul['idpodrucjeznanja'],
      aktivan: modul['aktivan'],
      ciljnastavnejedinice: modul['ciljnastavnejedinice'],
      rasporedpredavanja: modul['rasporedpredavanja'],
      fondsati: modul['fondsati'],
      vjezbe: modul['vjezbe']
    });
  }

  uredi(modul){
    // console.log(modul);
    let podaciZaSlanje = {
      'idmodul': this.modulId,
      'naziv': modul['naziv'],
      'idnacinpredavanja': modul['nacinPredavanja'],
      'idpodrucjeznanja': modul['podrucjeZnanja'],
      'aktivan': modul['aktivan'],
      'ciljnastavnejedinice': modul['ciljnastavnejedinice'],
      'rasporedpredavanja': modul['rasporedpredavanja'],
      'fondsati': modul['fondsati'],
      'vjezbe': modul['vjezbe'],
      'access_token': localStorage.getItem('tokenSql')
    }
    // console.log(podaciZaSlanje);
    this._nastavnejedinicePopisService.urediModul(podaciZaSlanje).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#nastavnejediniceTablica').DataTable().destroy();
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  dohvatiSveNacinepredavanja(){
    this._nastavnejedinicePopisService.dohvatiNacinepradavanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svinacinipredavanja = res.data;
      } else {
        this.svinacinipredavanja = [];
      }
    })
  }

  dohvatiSvaAktivnaPodrucjaznanja(){
    this._nastavnejedinicePopisService.dohvatiAktivnaPodrucjaznanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svapodrucjaznanja = res.data[0];
      } else {
        this.svapodrucjaznanja = [];
      }
    })
  }

  spremi(modulForma){
    //console.log(modulForma);
    let objektZaSlanje = {
      'naziv': modulForma['naziv'],
      'idnacinpredavanja': modulForma['nacinPredavanja'],
      'idpodrucjeznanja': modulForma['podrucjeZnanja'],
      'ciljnastavnejedinice': modulForma['ciljnastavnejedinice'],
      'rasporedpredavanja': modulForma['rasporedpredavanja'],
      'fondsati': modulForma['fondsati'],
      'vjezbe': modulForma['vjezbe']
    };
    // console.log(objektZaSlanje);
    if(modulForma['naziv'] && modulForma['nacinPredavanja'] && modulForma['podrucjeZnanja']){
      this._nastavnejedinicePopisService.dodajNastavnuJedinicu(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodana nastavna jedinica!");
          this.nastavnajedinicaForma = this._fb.group({
            naziv: [''],
            nacinPredavanja: [''],
            podrucjeZnanja: ['']
          });
          $('#nastavnejediniceTablica').DataTable().destroy();
          this.dohvati();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sveNastavnejedinice = [];
    this._nastavnejedinicePopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sveNastavnejedinice.push({
            'id': res.data[i]['idmodul'],
            'naziv': res.data[i]['mo_naziv'],
            'idnacinpredavanja': res.data[i]['idnacinpredavanja'], 
            'nacinpredavanja': res.data[i]['np_naziv'],
            'idpodrucjeznanja': res.data[i]['idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['pu_naziv'],
            'aktivan': res.data[i]['mo_aktivan'],
            'ciljnastavnejedinice': res.data[i]['mo_ciljnastavnejedinice'],
            'rasporedpredavanja': res.data[i]['mo_rasporedpredavanja'],
            'fondsati': res.data[i]['mo_fondsati'],
            'vjezbe': res.data[i]['mo_vjezbe']
          });
        }
        this.nastavnejediniceTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiNastavnuJedinicu(modul){
    //console.log(modul);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati nastavnu jedinicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._nastavnejedinicePopisService.obrisiNastavnuJedinicu({'idmodul': modul.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Nastavna jedinica uspješno obrisana!");
            $('#nastavnejediniceTablica').DataTable().destroy();
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja nastavne jedinice.');
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/nastavnejedinice-popis/nastavnejedinice-popis.component.ts